import { useEffect } from "react";
import { parseUrlParams } from "shared/helpers/urlHelpers";

type UseInitialView = (krpanoFeaturesReady: boolean) => void;

/**
 * # Pan/Zoom to an initial view
 *
 * Format: `initialview=ath, atv, fov, motiontype, shortestway, nonblocking, ondone`
 * Required: `ath` and `atv`
 * All others are optional and will use default values when not provided
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useInitialView: UseInitialView = (krpanoFeaturesReady) => {
  const initialView = parseUrlParams<string | null>("initialview", null);
  useEffect(() => {
    if (krpanoFeaturesReady && initialView) {
      window.krpano.call(`lookToWrapper(${initialView});`);
    }
  }, [krpanoFeaturesReady, initialView]);
};
